/* Feeternal shared behaviour. Any element with data-fe-open="<dialog id>" opens that <dialog class="fe-dialog"> as a modal;
   [data-fe-close] inside a dialog closes it; a click on the backdrop closes it. Delegated, so section re-renders need no re-binding. */
(() => {
  if (window.__feBase) return;
  window.__feBase = true;
  // Pop-ups sit below the header: keep --fe-dlg-top = the bottom edge of the visible header (announcement bar
  // included), so .fe-dialog and its backdrop start there and the header stays visible above the dim.
  const root = document.documentElement;
  let queued = false;
  const setTop = () => {
    queued = false;
    const header = document.querySelector('#header-component'); // #header-group is display: contents (no box)
    const bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    root.style.setProperty('--fe-dlg-top', `${Math.min(bottom, window.innerHeight / 2)}px`);
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(setTop); } };
  setTop();
  document.addEventListener('scroll', queue, { capture: true, passive: true }); // page-wrapper scrolls on desktop
  window.addEventListener('resize', queue, { passive: true });
  document.addEventListener('DOMContentLoaded', setTop);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const opener = target.closest('[data-fe-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-fe-open') || '');
      if (dialog instanceof HTMLDialogElement) {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
        return;
      }
    }
    const closer = target.closest('[data-fe-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog instanceof HTMLDialogElement) dialog.close();
      return;
    }
    if (target instanceof HTMLDialogElement && target.classList.contains('fe-dialog')) {
      const r = target.getBoundingClientRect();
      const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) target.close();
    }
  });

  // Search: the results showing fade while the next query's results load ('shopify:search:update' carries the request)
  let searchToken = 0;
  document.addEventListener('shopify:search:update', (event) => {
    const results = event.target instanceof Element ? event.target.querySelector('#predictive-search-results') : null;
    if (!results) return;
    const token = ++searchToken;
    results.setAttribute('data-fe-search-loading', '');
    Promise.resolve(/** @type {any} */ (event).promise)
      .catch(() => {})
      .finally(() =>
        requestAnimationFrame(() => {
          if (token !== searchToken) return;
          document.querySelector('#predictive-search-results')?.removeAttribute('data-fe-search-loading');
        })
      );
  });
})();
